import React, { useEffect } from "react";
import useMobileAccess from "../../hooks/useMobileAccess";
import { HOME_PATH, LOGIN_PATH, TEXTBOX } from "../../utils/constants";
import { newPageLog } from "../../utils/helpers";
import { ReactComponent as TELEPHONE } from "./images/telephone-purple.svg";
import PollIsClosedIllustration from "./images/poll-closed-illustration.gif";
import styles from "./styles.module.css";
import PollTitleContainer from "./PollTitleContainer";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import classes from "./styles.module.css";
import YuJaButton from "../../components/standardization/YuJaButton";
import {useHistory} from "react-router-dom";
import {useSession} from "../../hooks/useSession";
import { useTranslation } from "react-i18next";

export default function EndedPollForShareEach({pollTitle, websocketState}) {
    const { t } = useTranslation();
    let {width, height} = useWindowDimensions();
    const isNarrow = useMobileAccess(1200);
    const history = useHistory();
    const {isLoggedIn} = useSession();

    useEffect(() => {
      newPageLog("EndedPollNew.js");
    }, []);

    return (
        <div className={styles.endedPollBackground} style={{justifyContent: "normal"}}>
            <PollTitleContainer pollTitle={pollTitle} websocketState={websocketState}/>
            <div style={{flex: 1}}/>
            <div className={classes.waitingIllustrationWrapper} style={{width: 190, height: 190, marginTop: 30}}>
                <img
                    src={PollIsClosedIllustration}
                    alt="waiting"
                    style={{
                        width: 120,
                        height: 120,
                        flexShrink: 0,
                    }}
                />
            </div>
            <span className={styles.waitingRoomTitle}>
                {t("poll.creatorClosedPoll")}
            </span>
            <span className={styles.waitingRoomDesc} style={{textAlign: "center"}}>
                {t("poll.allResponsesSubmitted")}
            </span>

            <YuJaButton
                onClick={() => history.push({pathname: isLoggedIn() ? HOME_PATH : LOGIN_PATH})}
                style={{
                    fontSize: 14, 
                    lineHeight: 1.6,
                    width: 130,
                    height: 35,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                {t("poll.closeLabel")}
            </YuJaButton>
            <div/>

            <div className={classes.pollCloseSupportContainer} >
                <div className={classes.pollCloseIconProfile}>
                    <TELEPHONE/>
                </div>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 15,
                        padding: "20px 15px",
                        flex: 1,
                        minWidth: 0,
                        height: "100%"
                    }}
                >
                    <span className={styles.waitingRoomTitle} style={{fontSize: 18}}>
                        {t("questionBuilder.doNeedAssistanceText")}?
                    </span>
                    <span className={styles.waitingRoomDesc}>
                        {t("questionBuilder.pleaseContactSupportPrefix")}
                        <a
                            href="https://support.yuja.com/hc/en-us"
                            target="_blank"
                            style={{textDecoration: "none", fontWeight: "700", color: "#000"}}
                        >{t("support.yujaSupportTitle")}</a>
                        {t("questionBuilder.pleaseContactSupportSuffix")}
                    </span>
                </div>
            </div>
            <div style={{flex: 2}}/>
            {/*<span className={styles.endedPollText} style={{fontSize: isNarrow ? 14 : undefined}}>*/}
            {/*    {SUPPORT_PREFIX} <a href="https://support.yuja.com/hc/en-us" target="_blank">{YUJA_ENGAGE_SUPPORT}</a>*/}
            {/*</span>*/}
        </div>
    );
}
